import Getdatos from "../../../services/getDatos";
import { useEffect, useState, useContext } from "react";
import contextGeomedellin from "../../../context/contextGeomedellin";
import { Form } from "react-bootstrap";

export default function Secciones({ changeSearchSetVal }) {
  const { componentes } = useContext(contextGeomedellin);

  return (
    <>
      <Form.Select
        className="select-secciones focus-secciones"
        onChange={(e) => {
          changeSearchSetVal(e, "horizontal", 0, 1);
        }}
      >
        <option value={"-1"}>Secciones</option>
        {componentes
          .filter(({ id_componente }) => id_componente !== 4)
          .map((e, i) => {
            return (
                <option key={e.id_componente} value={e.id_componente}>
                  {e.nombre_componente}
                </option>
            );
          })}
      </Form.Select>
    </>
  );
}
